import React from 'react';
import DevOpsInterviewQA from '../components/DevOpsInterviewQA';

const DevOpsInterviewQAPage = () => {
  return (
    <div className="min-h-screen">
      <DevOpsInterviewQA />
    </div>
  );
};

export default DevOpsInterviewQAPage;
